<template>
  <div class="home">
    <van-sticky>
      <div
        class="homeNav"
        :style="{ 'padding-top': (isiOSX ? 44 : 24) + 'px' }"
      >
        <img
          class="navLeft"
          @click="goBack()"
          src="./../../../assets/decoration/back.png"
        />
        <span class="navTitle">装饰代理人</span>
      </div>
    </van-sticky>
    <!-- img -->
    <div class="content">
      <img src="./../../../assets/decoration/index/agent/1.png" alt="" />
      <img src="./../../../assets/decoration/index/agent/2.png" alt="" />
    </div>
    <div class="btm">
      <div>
        <span class="btn" @click="toApplyFor(1)" v-if="type == 1 || !type"
          >申请个人代理人</span
        >
        <span class="btn" @click="toApplyFor(2)" v-if="type == 2 || !type"
          >申请企业代理人</span
        >
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      isiOSX: false,
      is_white: false,
      userData: {},
      equipment: 10, //10安卓，11ios
      type: null, //1.只有个人代理人2.只有企业代理人
    };
  },
  created() {
    this.isiOSX = this.isIphoneX();
    if (this.$route.query.type) {
      this.type = this.$route.query.type;
    }
    this.$api.setToken(JSON.parse(sessionStorage.getItem("token")));
    this.deductionUA();
    this.getData();
  },
  mounted() {},
  methods: {
    // 判断手机机型
    deductionUA() {
      const ua = navigator.userAgent.toLowerCase();
      if (/iphone|ipad|ipod/.test(ua)) {
        this.equipment = 11;
      } else if (/android/.test(ua)) {
        this.equipment = 10;
      }
    },
    goBack() {
      if (this.equipment == 10) {
        this.params("", "1", "decorateBackOn");
      }
      if (this.type) {
        this.$router.go(-1);
      } else {
        this.$router.push({
          path: "/decoration/index",
          query: {
            token: JSON.parse(sessionStorage.getItem("token")),
          },
        });
      }
    },
    // 判断是否是白名单
    getData() {
      this.$api.post("decoration/member/white/exists").then((res) => {
        this.is_white = res.is_white;
      });
    },
    toApplyFor(type) {
      this.$api
        .get("decoration/member/city/agent/exists", {
          category: "apply",
        })
        .then((res) => {
          if (res.is_apply_enterprise_agent && res.is_apply_individual_agent) {
            this.$api.get("member/member/member/auth/detail").then((res) => {
              if (res.status == 2) {
                if (type == 1) {
                  // 个人
                  this.$router.push({
                    path: "/decoration/deputy/applyFor",
                    query: {
                      is_white: this.is_white,
                    },
                  });
                } else {
                  // 企业
                  this.$router.push({
                    path: "/decoration/deputy/enterpriseApplyFor",
                  });
                }
              } else {
                this.$dialog
                  .confirm({
                    title: "实名认证",
                    message: "为确认用户账号为本人持有，请先进行实名认证",
                    width: "280px",
                    confirmButtonColor: "#5853E9",
                    cancelButtonColor: "rgba(88, 83, 233, .1)",
                    confirmButtonText: "立即前往",
                    cancelButtonText: "取消",
                    theme: "round-button",
                  })
                  .then(() => {
                    this.params("", "", "personal");
                  })
                  .catch(() => {});
              }
            });
          } else {
            let message = "";
            if (this.type == 1) {
              message = "需等待企业代理人有效期结束后，才能申请该代理身份。";
            } else {
              message = "需等待个人代理人有效期结束后，才能申请该代理身份。";
            }
            this.$dialog
              .alert({
                message: message,
                confirmButtonText: "知道了",
                confirmButtonColor: "#5853E9",
              })
              .then(() => {});
          }
        });
    },
  },
};
</script>
<style lang="less">
.home {
  height: 100%;
  background: #f2f2f2;
  .homeNav {
    background: #ffffff;
    height: 44px;
    position: relative;
    .navLeft {
      width: 24px;
      height: 24px;
      position: absolute;
      left: 16px;
      bottom: 10px;
    }
    .navTitle {
      position: absolute;
      left: 50%;
      bottom: 10px;
      transform: translateX(-50%);
      font-size: 17px;
      font-weight: 700;
      color: #404247;
    }
  }
  .content {
    padding-bottom: 83px;
    display: flex;
    flex-direction: column;
    img {
      width: 100%;
    }
  }
  .btm {
    width: 100%;
    height: 83px;
    background-color: #ffffff;
    position: fixed;
    left: 0;
    bottom: 0;
    div {
      margin: 2px 13px 0;
      display: flex;
      .btn {
        flex: 1;
        margin: 0px 3px;
        background-color: #5853e9;
        border-radius: 25px;
        height: 46px;
        line-height: 46px;
        text-align: center;
        color: #ffffff;
        font-size: 16px;
      }
    }
  }
}
.van-dialog__confirm,
.van-dialog__cancel {
  margin: 0 8px;
  border-radius: 18px;
}
.van-dialog__cancel {
  color: #5853e9 !important;
}
</style>